  <mat-card class="example-card">
    <mat-card-header class="titreFrm">
      <mat-card-title>PARAM&Eacute;TRE CONTRAT</mat-card-title>
    </mat-card-header>
    <mat-card-content class="border">
      <div *ngIf="exist;else attente"></div>
      <ng-template #attente>
        <mat-progress-bar mode="indeterminate"></mat-progress-bar>
      </ng-template>
      
      <mat-card class="example-card carClass">
        <mat-card-content>
          <form  class="example-form" #form="ngForm">
            <div class="btn">
              <button (click)="ajouter(form)" [disabled]="disabledBtnAjouter" mat-raised-button class="colorGreen">
                <mat-icon>add</mat-icon>
                Ajouter</button>
            </div>
            <mat-form-field     appearance="outline"   style="width: 125px;">
              <mat-label>Type perso</mat-label>
              <mat-select [disabled]="disabledTypeColl" name="Perso_Type" #Perso_Type="ngModel" [(ngModel)]="data.Perso_Type"
                placeholder="Type perso" (selectionChange)="onPersoTypeChange($event.value)" required>
                <mat-option value="0">Collaborateur</mat-option>
                <mat-option value="2">Apprenant</mat-option>
              </mat-select>
            </mat-form-field>
            <mat-form-field     appearance="outline"   style="width: 170px;">
              <mat-label>Type</mat-label>
              <mat-select [disabled]="disabledTypeColl" name="type" #Perso_TypePerso="ngModel" [(ngModel)]="data.Perso_TypePerso" 
                placeholder="Type" required (selectionChange)="onPersoTypePersoChange($event.value)">
                <mat-option *ngFor="let liste of listeType" [value]="liste.DiverSys_Index">{{liste.DiverSys_Titre}}</mat-option>
              </mat-select>
            </mat-form-field>
            

            <mat-form-field     appearance="outline"   style="width: 170px;">
              <mat-label>Type contrat</mat-label>
              <mat-select name="PersoContrat_Type" #PersoContrat_Type="" [(ngModel)]="data.PersoContrat_Type"
                placeholder="Type contrat" required>
                <mat-option *ngFor="let type of listeTypeContratDiverSis" [value]="type.DiverSys_Index">
                  {{type.DiverSys_Titre}}</mat-option>
              </mat-select>
            </mat-form-field>
            <mat-form-field     appearance="outline"   style="width: 200px;">
              <mat-label>Déscription</mat-label>
              <input matInput name="PersoContrat_Description1" #PersoContrat_Description1="ngModel"
                [(ngModel)]="data.PersoContrat_Description1" placeholder="Déscription">
            </mat-form-field>
            <!-- <mat-form-field     appearance="outline"  style="width: 100px;">
              <input matInput name="avtContrat_DateModification" #avtContrat_DateModification="ngModel"
                [(ngModel)]="data.avtContrat_DateModification" [matDatepicker]="picker1" placeholder="Modification" required>
              <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
              <mat-datepicker #picker1></mat-datepicker>
            </mat-form-field> -->
            <mat-form-field     appearance="outline"   style="width: 150px;">
              <mat-label>Désignation</mat-label>
              <input matInput name="PersoContrat_Description" #PersoContrat_Description="ngModel"
                [(ngModel)]="data.PersoContrat_Description" placeholder="Désignation">
            </mat-form-field>

            <mat-checkbox name="PersoContrat_Fin" [(ngModel)]="data.PersoContrat_Fin">
              Existe date fin contrat
            </mat-checkbox>
            
            <!-- <div fxFlex="0 1 calc(20% - 10px)" fxFlex.lt-md="0 1 calc(44% - 10px)" fxFlex.lt-sm="100%">
            
              <h5>Couleur</h5>
                    
                <div style="margin-bottom: 10px;" fxLayout="row">
                  <h6 style="margin-right: 10px;" [style.background]="data.avtParamAction_ColorAction" [style.color]="data.avtParamAction_ColorText">Couleur action</h6><button [(colorPicker)]="data.avtParamAction_ColorAction" [style.background]="data.avtParamAction_ColorAction" ></button>
                </div>
                <div fxLayout="row">
                    <h6 style="margin-right: 27px;" [style.background]="data.avtParamAction_ColorAction" [style.color]="data.avtParamAction_ColorText">Couleur text</h6><button [(colorPicker)]="data.avtParamAction_ColorText" [style.background]="data.avtParamAction_ColorText" ></button>
                </div>
                
            </div>
           -->

          </form>
        </mat-card-content>
      </mat-card>
      <input type="file" style="display: none;" id="inputFilePersoContrat_Partiel" (change)="onChangeImagefile($event,1)">
      <input type="file" style="display: none;" id="inputFilePersoContrat_Plein" (change)="onChangeImagefile($event,2)">
      <app-avt-listes [multipleSelect]="false" #listeContratComponen [showFilter]="true" [heightTable]="'400'" [dataSourceBrut]="[]"
      [displayedColumnsBrut]="Columns" [listBtn]="listBtnContrat" (btnTable)="clickBtnHeat($event)">
    </app-avt-listes>

    </mat-card-content>
  </mat-card>

      <!-- <table mat-table [dataSource]="dataSource" class="mat-elevation-z8">
          <ng-container matColumnDef="PersoContrat_Code">
            <th mat-header-cell *matHeaderCellDef> Code </th>
            <td mat-cell *matCellDef="let element"> {{element.PersoContrat_Code}} </td>
          </ng-container>
          <ng-container matColumnDef="PersoContrat_Type">
            <th mat-header-cell *matHeaderCellDef>Déscription </th>
            <td mat-cell *matCellDef="let element"> {{element.PersoContrat_Type}} </td>
          </ng-container>
          <ng-container matColumnDef="PersoContrat_Description">
            <th mat-header-cell *matHeaderCellDef>Désignation </th>
            <td mat-cell *matCellDef="let element"> {{element.PersoContrat_Description}} </td>
          </ng-container>
         
          <ng-container matColumnDef="PersoContrat_Fin">
              <th mat-header-cell *matHeaderCellDef> Fin Contrat </th>
              <td mat-cell *matCellDef="let element"><mat-checkbox disabled="true"  [ngModel]="element.PersoContrat_Fin"></mat-checkbox></td>
          </ng-container>
         
  
          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;" (click)="selectRow($event,row)"></tr>
        </table> -->